// src/services/costsApi.js
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

/**
 * Se il token è presente in localStorage, ritorna l'header "Authorization: Bearer <token>"
 */
function getAuthHeaders() {
  const token = localStorage.getItem("access_token");
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
}

/**
 * OVERHEAD COSTS
 */

// GET /admin/overhead_costs
export async function fetchOverheadCosts(params = {}) {
  // Esempio: params = { restaurant_id: 123 }
  const response = await axios.get(`${BASE_URL}/admin/overhead_costs`, {
    params,
    headers: getAuthHeaders()
  });
  return response.data; // Array di OverheadCostRead
}

// POST /admin/overhead_costs
export async function createOverheadCost(payload) {
  const response = await axios.post(
    `${BASE_URL}/admin/overhead_costs`,
    payload,
    {
      headers: getAuthHeaders()
    }
  );
  return response.data; // OverheadCostRead
}

// PATCH /admin/overhead_costs/:costId
export async function updateOverheadCost(costId, payload) {
  const response = await axios.patch(
    `${BASE_URL}/admin/overhead_costs/${costId}`,
    payload,
    {
      headers: getAuthHeaders()
    }
  );
  return response.data; // OverheadCostRead
}

// DELETE /admin/overhead_costs/:costId
export async function deleteOverheadCost(costId) {
  await axios.delete(`${BASE_URL}/admin/overhead_costs/${costId}`, {
    headers: getAuthHeaders()
  });
  return true;
}

/**
 * EXTRA REVENUES
 */

// GET /admin/extra_revenues
export async function fetchExtraRevenues(params = {}) {
  // Esempio: params = { restaurant_id: 123 }
  const response = await axios.get(`${BASE_URL}/admin/extra_revenues`, {
    params,
    headers: getAuthHeaders()
  });
  return response.data; // Array di ExtraRevenueRead
}

// POST /admin/extra_revenues
export async function createExtraRevenue(payload) {
  const response = await axios.post(
    `${BASE_URL}/admin/extra_revenues`,
    payload,
    {
      headers: getAuthHeaders()
    }
  );
  return response.data; // ExtraRevenueRead
}

// PATCH /admin/extra_revenues/:revenueId
export async function updateExtraRevenue(revenueId, payload) {
  const response = await axios.patch(
    `${BASE_URL}/admin/extra_revenues/${revenueId}`,
    payload,
    {
      headers: getAuthHeaders()
    }
  );
  return response.data; // ExtraRevenueRead
}

// DELETE /admin/extra_revenues/:revenueId
export async function deleteExtraRevenue(revenueId) {
  await axios.delete(`${BASE_URL}/admin/extra_revenues/${revenueId}`, {
    headers: getAuthHeaders()
  });
  return true;
}
